<template>
  <v-container id="dashboard" fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="display-1 font-weight-bold has-border">Ledger</v-subheader>
        </div>
      </v-col>
      <v-col v-if="modules.FranchiseePayments" cols="13" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'franchiseeOrderNodal' }" title="Franchisee Payments">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-cart-arrow-right" color="warning" cardTitle="Franchisee Payments  "> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.StudentLedger" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'studentList' }" title="Student Ledger">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-account-tie" color="pink" cardTitle="Student Ledger"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.BrainBeesLedger" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'ledger' }" title="BrainBees Ledger">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-storefront" color="accent" cardTitle="BrainBees Ledger"> </clickable-card>
        </router-link>
      </v-col>

      <v-col v-if="modules.FranchiseeCollectionPaymentDetails" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'ledgerDetailFranchisee' }" title="Franchisee Ledger">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-storefront" color="accent" cardTitle="Franchisee Collection &amp; payment details"> </clickable-card>
        </router-link>
      </v-col>

      <v-col v-if="modules.NodalLedger" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'nodalLedgerList' }" title="Nodal Ledger">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-store" color="accent" cardTitle="Nodal Ledger"> </clickable-card>
        </router-link>
      </v-col>

      <v-col v-if="modules.FranchiseeKitOrder"  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'franchiseeKitOrder' }" title="Franchisee Kit Order">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-lightbulb-on-outline" color="info" cardTitle="Franchisee Kit Order"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.NodalPayment" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'nodalPaymentTransfer' }" title="Nodal Payment ">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-credit-card-outline" color="green" cardTitle="Nodal Payment"> </clickable-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClickableCard from '@/components/template/ClickableCard'
import Utils from '@/utils'

export default {
  components: { ClickableCard },
  name: 'nodalLedger',
  data () {
    return {
      modules: {
        FranchiseePayments: this.checkModuleAccess('FranchiseePayments'),
        StudentLedger: this.checkModuleAccess('StudentLedger'),
        BrainBeesLedger: this.checkModuleAccess('BrainBeesLedger'),
        FranchiseeCollectionPaymentDetails: this.checkModuleAccess('FranchiseeCollectionPaymentDetails'),
        NodalLedger: this.checkModuleAccess('NodalLedger'),
        FranchiseeKitOrder: this.checkModuleAccess('FranchiseeKitOrder'),
        NodalPayment: this.checkModuleAccess('NodalPayment')

      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
